import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommonsService } from 'src/app/services/commons.service';
import { EntitiesService } from 'src/app/services/entities.service';
import { SigninService } from 'src/app/services/signin.service';
import { CONSTANTS } from 'src/app/shared/constants';
import { WarningTermsPolityComponent } from 'src/app/components/modals/warning-terms-polity/warning-terms-polity.component';
import { trigger, style, animate, transition } from '@angular/animations';


// import { AuthService, SocialUser, GoogleLoginProvider } from "angularx-social-login";

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class SigninComponent implements OnInit {

  ss = sessionStorage;
  show = this.ss.getItem('form') ? this.ss.getItem('form') : '1';
  signForm: UntypedFormGroup;
  key: string;
  wrongPass: boolean;
  type = 'password';
  squals = true;
  showProgress = false;
  showProgressConsumer = false;
  formatInvalid: boolean;
  receptionMessage: string;
  param = [];
  firstInit: boolean;
  country: string;
  language: string;
  saveInfor: any;
  showTerms = false; // inicializar a falso -------------------------------------------------------------------------------------------------
  data: any;
  startMessage = '¡Bienvenido a Akana!';
  buttonName = 'Iniciar sesión';
  checkedTerms: boolean;
  firstCall = true;
  code = 200;
  validPassTwo = true;
  // private user: SocialUser;

  constructor(private f: UntypedFormBuilder,
    private r: Router,
    private cs: CommonsService,
    private sign: SigninService,
    private rc: ReCaptchaV3Service,
    private se: EntitiesService,
    private snackBar: MatSnackBar,
    private modal: MatDialog
    ) {
    // private googleAuth: AuthService) {
    // this.googleAuth.authState.subscribe((user) => {
    //   console.log(user);
    //   this.user = user;
    // });
  }

  ngOnInit() {
    this.checkFormOne();
    this.getKey();
    this.cs.reloadOTBanner();
    this.cs.clearDup();
    this.cs.firstChargePage('Sign In', 'Inicion de sesion', 'funnel');
    this.cs.eventsAnalitics('visit screen', 'content', 'Signin');
    this.createForm();
    this.getParams();
    this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
  }

  /**
   * este metodo trae un modal para que inicies sesion de google
   */
  // signInWithGoogle(): void {
  //   this.googleAuth.signIn(GoogleLoginProvider.PROVIDER_ID);
  // }


  /**
   * comprueba que exista una sesion de form_sign
   */
  checkFormOne = () => {
    if (!this.ss.getItem('form') || this.ss.getItem('form') === '1') {
      this.ss.removeItem('form_sign');
    }
  }

  getParams = () => {
    const url = window.location.href;
    let aux = '';
    if (url.includes('?pw=')) { // cambio de contraseña
      aux = url.split('?pw=')[1];
      this.startMessage = 'Cambio de contraseña';
      this.buttonName = 'Cambiar';
      this.signForm.addControl('passwordTwo', new UntypedFormControl('', [Validators.required]));
      this.signForm.controls['password'].setValidators([Validators.required,
        this.patternValidator(/(?=^.{8,64}$)(?=.*\d)(?=.*\W)(?=.*[A-Z])(?=.*[a-z])(?!.*[\s\-\'\;'""]).*$/, { hasNumber: true }),
      ])
      this.checkPassObservable();
      this.param = ['change', aux.substr(0, aux.length)];
    } else if (url.includes('?p=')) { // desbloqueo de usuario
      aux = url.split('?p=')[1];
      this.startMessage = 'Desbloqueo de usuario';
      this.buttonName = 'Desbloquear';
      this.signForm.addControl('passwordTwo', new UntypedFormControl('', [Validators.required]));
      this.checkPassObservable();
      this.param = ['unlock', aux.substr(0, aux.length)];
    } else if (url.includes('?l=')) { // activacion de usuario a traves de correo
      aux = url.split('?l=')[1];
      if (aux.substr(0, aux.length) && this.firstCall) {
        this.firstCall = false;
        this.firstInit = true;
        this.showProgress = true;
        this.receptionMessage = 'Realizando comprobaciones, espere por favor';

        this.sign.userActivate({ code: aux.substr(0, aux.length) }).subscribe((d: any) => {
          this.code = d.Code;
          if (d && d.Code === 403) {
            setTimeout(() => {
              this.signForm = null;
              this.ss.removeItem('form_sign');
              this.receptionMessage = d.Message;
              this.showProgress = false;
            }, 3000);
            return;
          }
          if (d && d.Code === 200) {
            this.receptionMessage = 'Usuario activado correctamente, espere';
            setTimeout(() => {
              this.showProgress = false;
              this.ss.removeItem('form_sign');
              this.changeForm('1', 's');
              const v = window;
              v.location.href = v.location.origin + '/FRONT/#/signin';
              location.reload();
            }, 3000);

          }
          this.ss.setItem('t', d.Token);
          // this.getEntities(d.Token, 'Usuario activado');
        });
      }
      this.param = ['l', aux.substr(0, aux.length)];
    } else if (url.includes('?su=')) { // Configura la pagina en crear sesión si el paramétro está disponible
      this.changeForm('2');
    }
  }


  changeForm = (num: string, special?: string) => {
    if (num === this.show && !special) {
      return;
    }
    if (special) {
      this.signForm = null;
      this.firstInit = false;
      this.saveInfor = null;
      this.showProgress = false;
      this.ss.setItem('form', '1');
      this.receptionMessage = null;
      this.createForm();
    } else {
      this.removeTermsAndPolity();
      this.signForm = null;
      this.ss.removeItem('form_sign');
      this.show = num;
      this.firstInit = false;
      this.saveInfor = null;
      this.ss.setItem('form', num);
      this.showProgress = false;
      this.showProgressConsumer = false;
      this.receptionMessage = null;
      this.createForm();
    }

  }

  /**
   * comprueba la password en busca de coincidencias
   */
  checkPassObservable = () => {
    this.signForm.valueChanges.subscribe(form => {
      this.saveInfor = form;
      if (form.passwordTwo === form.password) {
        this.signForm.controls.passwordTwo.setErrors(null);
        this.squals = false;
        this.validPassTwo = true;
      } else {
        this.signForm.controls.passwordTwo.setErrors({ wrongPass: true });
        this.validPassTwo = false;
        this.squals = true;
      }
    });
  }

  clearTermsAndConditions = () => {
    this.ss.removeItem('terms');
    this.ss.removeItem('polity');
  }

  createForm = () => {
    this.signForm = this.f.group({
      email: new UntypedFormControl(this.getValuesForm('email', 's'), [Validators.pattern(CONSTANTS.REG_EXP_MAIL), Validators.required]),
      password: new UntypedFormControl(this.getValuesForm('password', 's'), [Validators.required])}, {});
    if (this.show === '1') {
     // this.getParams();
      this.cs.eventsAnalitics('click', 'Inicio session', 'Signin');
      this.formValidation();
      this.signForm.controls['password'].setValidators([Validators.required])
    } else if (this.show === '2') {
      this.signForm.controls['password'].setValidators([Validators.required,
        this.patternValidator(/(?=^.{8,64}$)(?=.*\d)(?=.*\W)(?=.*[A-Z])(?=.*[a-z])(?!.*[\s\-\'\;'""]).*$/, { hasNumber: true }),
      ])
      this.ss.removeItem('signinSCF');
      this.cs.eventsAnalitics('click', 'Crear cuenta', 'Signin');
      this.ss.removeItem('email');
      this.signForm.addControl('passwordTwo', new UntypedFormControl(this.getValuesForm('passwordTwo', 's'), [Validators.required]));
      this.signForm.addControl('termsAndConditions', new UntypedFormControl(this.getValuesForm('termsAndConditions', 'b') || this.readTermsAndConditions(), [Validators.required]));
      this.signForm.addControl('ofers', new UntypedFormControl(this.getValuesForm('ofers', 'b')));
      this.checkPassObservable();
      if (this.ss.getItem('form_sign')) {
        const form = JSON.parse(this.ss.getItem('form_sign'));
        if (form && form.password !== form.passwordTwo) {
          this.validPassTwo = false;
        }
      }
    } else if (this.show === '3') {
      this.cs.eventsAnalitics('click', '¿Has olvidado tu contraseña?', 'Signin');
      this.ss.removeItem('email');
      this.signForm.removeControl('password');
    }
  }

  formValidation = () => {
    this.signForm.valueChanges.subscribe(data => {
      if (data.email && !CONSTANTS.REG_EXP_MAIL.test(data.email) || !data.email && !this.signForm.get('email').value) {
        this.signForm.controls.email.setErrors({ emailInvalid: true });
      } else {
        this.ss.setItem('email', data.email);
        this.signForm.controls.email.setErrors(null);
      }
    });
  }

  /**
   * recupera valor del objeto del formulario en caso de que se vaya a otra vista
   * @param name: string nombre del objeto form
   * @param type: string b -> boolean, s -> string
   */
  getValuesForm = (name: string, type: string) => {
    if (type === 's') {
      return this.saveInfor ? this.saveInfor[name] : this.checkFormSession() !== null ? this.checkFormSession()[name] : '';
    } else if (type === 'b') {
      return this.saveInfor ? this.saveInfor[name] : this.checkFormSession() ? this.checkFormSession()[name] : false;
    }
  }

  /**
   * si parsea la sesion guardada en el caso de que sean 
   */
  checkFormSession = (): any => {
    return this.sessionNullOrUndefinedString() ? JSON.parse(this.ss.getItem('form_sign')) : null;
  }

  /**
   * Comprueba que la sesion guardada no sea un null o undefined string
   */
  sessionNullOrUndefinedString = () => {
    return this.ss.getItem('form_sign') && this.ss.getItem('form_sign') !== 'undefined'
      && this.ss.getItem('form_sign') !== 'null';
  }


  /**
   * lee si hay algun termino y c
   */
  readTermsAndConditions() {
    if (sessionStorage.getItem('terms') && sessionStorage.getItem('polity')) {
      this.checkedTerms = false;
      return true;
    } else {
      this.checkedTerms = true;
      return false;
    }
  }

  openWarmModal() {
    if (this.readTermsAndConditions()) {
      this.cs.eventsAnalitics('click', 'Aceptar terminos y condiciones de uso', 'terms');
      return;
    } else {
      if (!this.saveInfor && this.sessionNullOrUndefinedString()) {
        this.saveInfor = JSON.parse(this.ss.getItem('form_sign'));
      }
      this.ss.setItem('form_sign', JSON.stringify(this.saveInfor));

      const modalConfig = new MatDialogConfig();
      modalConfig.data = {signin: true};
      modalConfig.width = '320px';
      modalConfig.id = 'modal-info';
      modalConfig.maxWidth = '500px';
      this.modal.open(WarningTermsPolityComponent, modalConfig);
      this.checkedTerms = true;
    }
  }

  /**
   * recupera una ruta y te lleva a ella
   * @param r: string;
   */
  goToUrl = (r: string, optional?: string) => {
    this.cs.eventsAnalitics('click', 'SIGN-IN', 'signin');
    if (r === 'terms-conditions?signin=true' || r === 'privacy-polity' && this.show === '2') {
      this.ss.setItem('login_polity', '1');
      this.ss.setItem('form', this.ss.getItem('form') || this.show);
      if (!this.saveInfor && this.sessionNullOrUndefinedString()) {
        this.saveInfor = JSON.parse(this.ss.getItem('form_sign'));
      }
      this.ss.setItem('form_sign', JSON.stringify(this.saveInfor));
      r = (this.country) + '/' + r;
    }
    if (this.ss.getItem('form') === '1') {
      this.ss.removeItem('form');
    }
    if (optional === 'inv') {
      this.removeTermsAndPolity();
    }
    this.r.navigateByUrl(r);
  }


  /**
   * recupera una clave que se usa para el google captcha
   */
  getKey = () => {
    if (!sessionStorage.getItem('k_ca')) {
      this.sign.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  /**
   * Muestra la password al mantenerla pulsada
   * @param num: number
   */
  showPass = (num: number) => {
    if (num === 1) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  analiticsGoogle = () => {
    if (!this.signForm.get('ofers').value) {
      this.cs.eventsAnalitics('click', 'Aceptar ofertas y promociones', 'signin');
    }
  }

  /**
   * comprueba que es correcto el filtro propuesto del captcha
   * @param data: any
   * @param step: number
   */
  recaptchaCheck = (data, step) => {
    this.rc.execute(this.key, 'login', (token) => {
      this.successCaptcha(data, token, step);
    }, { useGlobalDomain: true });
  }

  successCaptcha = (data, token, step) => {
    this.receptionMessage = null;
    switch (step) {
      case 1:
        this.sign.loginAkana(data, token).subscribe((d: any) => {
          switch (d.Code) {
            case 300: // primera vez que entra en la app por login
              this.ss.setItem('t', d.Token);
              this.getEntities(d.Token, 'Inicio de sesion correcto');
              break;
            case 401: // error al introducir credenciales
              this.showProgress = false;
              this.receptionMessage = d.Message;
              break;
            case 406: // numero de intentos superados
              this.showProgress = false;
              this.receptionMessage = d.Message;
              break;
            case 200: // recupera su informe y te redirige a resumen
              this.sign.globalPosition(d.Token).subscribe((c: any) => {
                this.ss.setItem('t', c.Token);
                sessionStorage.setItem('_k', this.cs.encrypt(c));
                this.cs.setKpi(c);
                this.cs.eventsAnalitics('conversion', 'Informe recuperado correctamente', 'signin');
                this.r.navigateByUrl('global-position');
              });
              break;
          }
        }, err => {
          this.showProgress = false;
          console.error(err);
        });
        break;
      case 2:
        this.sign.signUp(data, token).subscribe((d: any) => {
          this.code = d.Code;
          if (d && d.Code !== 200) {
            this.showProgress = false;
            this.receptionMessage = d.Message;
            return;
          }
          this.showProgress = false;
          this.receptionMessage = d.Message;
          this.clearTermsAndConditions();
          this.ss.removeItem('form_sign');
          this.cs.eventsAnalitics('conversion', 'Registro de usuario nuevo', 'OK');
        }, err => {
          console.error(err);
          this.showProgress = false;
        });
        break;
      case 3:
        if (this.signForm.controls.password) {
          this.sign.recoverPass(data, token).subscribe((d: any) => {
            if (d && d.Code !== 200) {
              this.showProgress = false;
              this.smallModal('La contraseña ya se actualizo anteriormente');
              setTimeout(() => {
                const v = window;
                v.location.assign(v.location.origin + '/FRONT/#/signin');
                location.reload();
              }, 3000);
              return;
            }
            this.startMessage = '¡Bienvenido a Akana!';
            this.buttonName = 'Iniciar sesión';
            const body = {
              Name: this.signForm.get('email').value,
              Value: this.signForm.get('password').value,
            };
            this.signForm.removeControl('passwordTwo');
            this.signForm.reset();
            this.showProgress = false;
            this.receptionMessage = null;
            this.ss.setItem('form', '1');
            // CAMBIAR CUANDO SE HAGAN CAMBIOS EN EL SERVIDOR------------------------------------------------------------
            this.smallModal('Contraseña actualizada correctamente');
            this.cs.eventsAnalitics('conversion', 'Se ha recuperado la contraseña', 'OK');
            setTimeout(() => {
              const v = window;
              v.location.assign(v.location.origin + '/FRONT/#/signin');
              location.reload();
            }, 3000);
          }, err => {
            console.error(err)
            this.showProgress = false;
          });
        } else {
          this.sign.sendMail(data, token).subscribe((d: any) => {
            if (d && d.Code !== 200) {
              this.showProgress = false;
              return;
            }
            this.receptionMessage = d.Message;
            this.showProgress = false;
            this.cs.eventsAnalitics('conversion', 'Recuperacion de contraseña', 'OK');
          }, err => {
            console.error(err);
            this.showProgress = false;
          });
        }
        break;
      case 4:
        this.sign.signInSCF(data, token).subscribe((d: any) => {
          switch (d.Code) {
            case 300:
              this.ss.setItem('t', d.Token);
              this.getEntities(d.Token, 'Inicio Santander Consumer');
              break;
            case 401:
              this.receptionMessage = 'Alguno de los campos introducidos no es correcto';
              break;
            case 402:
              this.data = [d.Hash, d.Channel];
              this.login(7);
              break;
            case 403:
              this.receptionMessage = d.Message;
              this.showProgress = false;
              break;
            case 200:
              this.showProgress = false;
              this.sign.globalPosition(d.Token).subscribe((c: any) => {
                this.ss.setItem('t', c.Token);
                sessionStorage.setItem('_k', this.cs.encrypt(c));
                this.cs.setKpi(c);
                this.cs.eventsAnalitics('conversion', 'Informe recuperado correctamente', 'signin');
                this.r.navigateByUrl('global-position');
              });
              break;
          }
        });
        break;
      case 5:
        this.sign.unLockUser(data, token).subscribe((d: any) => {
          this.showProgress = false;
          if (d.Code === 200) {
            this.signForm.removeControl('passwordTwo');
            this.startMessage = '¡Bienvenido a Akana!';
            this.buttonName = 'Iniciar sesión';
            this.smallModal('Usuario desbloqueado correctamente');
            const body = {
              Name: this.signForm.get('email').value,
              Value: this.signForm.get('password').value,
            };
            this.recaptchaCheck(body, 1);
          }
        }, err => {
          console.error(err);
          this.showProgress = false;
        });
        break;
      case 7:
        this.sign.termsAndConditions(data, token).subscribe((d: any) => {
          this.ss.setItem('t', d.Token);
          this.getEntities(d.Token, 'Inicio sesion con usuario de santander consumer');
        });
        break;
    }
  }

  login = (n: number) => {
    if (this.signForm.invalid || !this.validPassTwo) {
      return;
    }
    let body = null;
    this.showProgress = true;
    this.receptionMessage = '';
    switch (n) {
      case 1:
        if (this.param.length) {
          if (this.param[0] === 'change') {
            body = {
              Code: this.param[1],
              Pass: this.signForm.get('password').value
            };
            this.recaptchaCheck(body, 3);
          } else if (this.param[0] === 'unlock') {
            body = {
              Code: this.param[1],
              Pass: this.signForm.get('password').value
            };
            this.recaptchaCheck(body, 5);
          } else {
            body = {
              Name: this.signForm.get('email').value,
              Value: this.signForm.get('password').value,
            };
            this.recaptchaCheck(body, n);
          }
        } else {
          body = {
            Name: this.signForm.get('email').value,
            Value: this.signForm.get('password').value,
          };
          this.recaptchaCheck(body, n);
        }
        break;
      case 2:
        body = {
          Email: this.signForm.get('email').value,
          PValue: this.signForm.get('password').value,
          TyCS: this.signForm.get('termsAndConditions').value,
          PolPri: this.signForm.get('ofers').value
        };
        this.recaptchaCheck(body, 2);
        break;
      case 3:
        this.recaptchaCheck(this.signForm.get('email').value, 3);
        break;
      case 4:
        body = {
          IdentificationNumber: this.signForm.get('dni').value,
          Password: this.signForm.get('password_scf').value
        };
        this.recaptchaCheck(body, 4);
        break;
      case 7:
        body = {
          IdentificationNumber: this.data[0],
          Channel: this.data[1],
          CentroId: 0,
          TyCS: this.signForm.get('termsAndConditions').value,
          PolPri: this.signForm.get('ofers').value,
          Country: this.country,
          Language: this.language + '_' + this.language.toUpperCase()
        };
        this.recaptchaCheck(body, 7);
        break;
    }
  }

  private smallModal(phrase) {
    this.snackBar.open(phrase, '', {
      duration: 3000,
    });
  }

  private getEntities = (t, d) => {
    this.se.getEntities(t).subscribe(data => {
      this.cs.setEntities(data.banks);
      this.cs.finishSession();
      this.cs.eventsAnalitics('conversion', d, 'OK');
      //this.se.getTink(t).subscribe(data => window.location.href = data);
      this.r.navigateByUrl('/login');
      this.show = '1';
    }, error => {
      this.showProgress = false;
    });
  }

  private patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  removeTermsAndPolity = () => {
    this.ss.removeItem('terms');
    this.ss.removeItem('polity');
  }
}
